import React, { Component } from "react";
import TabBorderItem from "./items/border";
import LachakToranjTabCornerItem from "./items/corner";
import LachakToranjTabToranjItem from "./items/toranj";
import LachakToranjTabBackgroundItem from "./items/lachakToranjBackground";

export default class LachakToranjTabItems extends Component {
  render() {
    const { stepOnboarding } = this.props;

    return (
      <ul
        className="ul-background-select"
        style={{ zIndex: stepOnboarding === 3 ? 1 : 0 }}
      >
        <TabBorderItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
        <LachakToranjTabCornerItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
        <LachakToranjTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
        <LachakToranjTabToranjItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
      </ul>
    );
  }
}
